// extracted by mini-css-extract-plugin
export var actionIcon = "_qf-0";